/**
 * Parse all VTT-markup into valid HTML
 *
 * @example
 *  <purple>Dörklockan ringer</purple>
 *  =
 *  <span class="purple">Dörrklockan ringer</span>
 *
 * @param {VTTCue} cue to transform
 */
const cueToHtmlString = (cue) => {
    const lines = cue.text.split('\n').map((line) => {
        if (line.indexOf('<') !== 0) {
            line = '<span>' + line + '</span>';
        }

        return line;
    });

    const str = lines.join(lines.length > 1 ? '<br>' : '');

    return str.replace(/<c\.(.*?)>/g, '<span class="$1">').replace(/<\/c\.(.*?)>/g, '</span>');
};

const getOrCreateRegionElement = (domElement) => {
    const domRegionElements = domElement.getElementsByClassName('region');

    // Check for existing region element
    if (domRegionElements.length > 0) {
        return domRegionElements[0];
    }

    // Create new region element
    const domRegionElement = document.createElement('div');
    domRegionElement.className = 'region';
    domElement.appendChild(domRegionElement);

    return domRegionElement;
};

export const renderCues = (domElement, cues) => {
    const domRegionElement = getOrCreateRegionElement(domElement);

    if (cues.length > 0/* && this.activeTextTrack.mode === 'hidden' */) {
        const activeCue = cues[0];

        /*
            14 is the calculated number of rows that fit into our video player viewport

            @example
            - line = 0: Top
            - line = 14: Bottom
            - line = 7: Middle

            Positive line numbers indicate top down.
            Negative line numbers indicate bottom up.

            However, since we are doing our own styling, it's easier to transform all negative
            line numbers into positive numbers.

            @example
            - line = -1: 14
            - line = -14: 0
            - line = -7: 7


            (Line is not supported by Edge and Safari)
        */
        const activeCueLine = activeCue.line < 0 ? 15 + activeCue.line : 14;

        // VTT Cue markup to HTML
        domRegionElement.innerHTML = cueToHtmlString(activeCue);

        // The line number is here translated to inline CSS
        domRegionElement.style.top = `calc(100% / 16 * ${activeCueLine - 1})`;
    } else {
        domRegionElement.innerHTML = '';
    }
};




// WEBPACK FOOTER //
// ./src/js/modules/vtt.js